import {
  Container,
  Grid,
  Box,
  TextField,
  Button,
  Snackbar,
  Slide,
  Fade,
  FormLabel,
  useTheme,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useState, useEffect, useRef } from "react";

import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import SendIcon from "@material-ui/icons/Send";
import { Loading } from "../../components/shared/loading";
import { TypingQuote } from "../../components/shared/TypingQuote";
import PlaceIcon from "@material-ui/icons/Place";
import EmailIcon from "@material-ui/icons/Email";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import YouTubeIcon from '@material-ui/icons/YouTube';
import PhoneIcon from '@material-ui/icons/Phone';

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9)), url("/static/contact.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  section: {
    padding: "40px 0",
    background: "#fafafa",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  formCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
    },
  },
  formTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: 4,
  },
  formSubtitle: {
    fontSize: "0.8rem",
    color: "#666666",
    marginBottom: 20,
    lineHeight: 1.5,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#fafafa",
      fontSize: "0.85rem",
      "& input": {
        padding: "10px 12px",
      },
      "&.Mui-focused": {
        backgroundColor: "#ffffff",
        "& fieldset": {
          borderColor: "#4c004c",
          borderWidth: 1.5,
        },
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.85rem",
      "&.Mui-focused": {
        color: "#4c004c",
      },
    },
  },
  submitButton: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4c004c 100%)",
    color: "#ffffff",
    padding: "10px 32px",
    borderRadius: 8,
    fontSize: "0.85rem",
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 2px 8px rgba(76, 0, 76, 0.25)",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(76, 0, 76, 0.35)",
    },
    "&:disabled": {
      background: "#cccccc",
      boxShadow: "none",
    },
  },
  contactCard: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4c004c 100%)",
    borderRadius: "12px",
    padding: "24px",
    height: "100%",
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
      marginTop: 16,
    },
  },
  contactTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#ffffff",
    marginBottom: 16,
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: 14,
    "& svg": {
      fontSize: 18,
      color: "rgba(255,255,255,0.8)",
      marginRight: 12,
      marginTop: 2,
    },
  },
  contactText: {
    fontSize: "0.8rem",
    color: "rgba(255,255,255,0.9)",
    lineHeight: 1.5,
  },
  socialContainer: {
    display: "flex",
    gap: 8,
    marginTop: 20,
  },
  socialButton: {
    width: 36,
    height: 36,
    backgroundColor: "rgba(255,255,255,0.1)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    border: "1px solid rgba(255,255,255,0.2)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)",
      transform: "translateY(-2px)",
    },
    "& svg": {
      fontSize: 18,
      color: "#ffffff",
    },
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
}));

export const Contact = () => {

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const mobileRef = useRef(null);
  const subjectRef = useRef(null);
  const messageRef = useRef(null);

  const theme = useTheme();
  const classes = useStyles();
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);
  //const [checked, setChecked] =  useState(true);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mob, setMob] = useState("");
  const [subj, setSubj] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState(0);
  const [disablebutton, setDisablebutton] = useState(false);

  const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("success");
  const [snackBarType, setSnackBarType] = useState("Invalid");

  const openSnkbar = (type, msg) => {
    setSnackBarMsg(msg);
    setSnackBarType(type);
    setSnackBar(true);
  };

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 5);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
  };

  const onSubmit = () => {
    setErr(0);
    if (name == "") {
      setErr(1);
       
      if (nameRef.current) {
          nameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter Your Name....");
    } else if (!email.includes("@")) {
      setErr(2);
      if (emailRef.current) {
        emailRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter a Valid Email-Id....");
    } else if (mob.length > 15 || mob.length < 9 || /[a-zA-Z]/.test(mob)) {
      setErr(3);
      if (mobileRef.current) {
        mobileRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter a Valid Mobile Number....");
    } else if (subj == "") {
      setErr(4);
      if (subjectRef.current) {
        subjectRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter Your Subject....");
    } else if (msg == "") {
      setErr(5);
      if (messageRef.current) {
        messageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter Your Message....");
    } else {
      openSnkbar("warning", "Please wait.....");
      setDisablebutton(true);
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("mob", mob);
      formData.append("sub", subj);
      formData.append("msg", msg);
      Axios.post("/api/contactnow", formData, {
        headers: { headKey: headKey },
      }).then((res) => {
        if (res.data.status) {
          setDisablebutton(false);
          setName("");
          setEmail("");
          setMob("");
          setSubj("");
          setMsg("");
          openSnkbar("success", res.data.msg);
        } else {
          setDisablebutton(false);
          openSnkbar("error", "Something went wrong... try later.");
        }
      });
    }
  };

  
  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>
      {/* Hero Section */}
      <Box className={classes.heroSection}>
        <Fade in={true} timeout={1000}>
          <Box className={classes.heroContent}>
            <Typography className={classes.heroTitle}>
              Contact Us
            </Typography>
            <Box className={classes.heroDivider} />
            <Typography className={classes.heroSubtitle}>
              Discover How We Can Fulfill Your Diverse Software Needs with Excellence
            </Typography>
          </Box>
        </Fade>
      </Box>

      {isloading ? (
        <Loading />
      ) : (
        <Box className={classes.section}>
          <Container maxWidth="lg">
            {/* Snackbar for notifications */}
            <Snackbar
              open={snackBar}
              autoHideDuration={4000}
              onClose={() => setSnackBar(false)}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert
                onClose={() => setSnackBar(false)}
                severity={snackBarType}
                style={{ color: snackBarType === "warning" ? "black" : "white" }}
              >
                {snackBarMsg}
              </Alert>
            </Snackbar>

            <Slide direction="up" in={true} timeout={800}>
              <Box>
                <Typography className={classes.sectionTitle}>
                  Get in Touch
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  We're here to listen, assist, and partner with you
                </Typography>
              </Box>
            </Slide>

            <Grid container spacing={4}>
              {/* Contact Form */}
              <Grid item xs={12} md={7}>
                <Fade in={true} timeout={1000}>
                  <Box className={classes.formCard}>
                    <Typography className={classes.formTitle}>
                      Send Us a Message
                    </Typography>
                    <Typography className={classes.formSubtitle}>
                      Please provide us with your requirements, and one of our consultants will be in touch shortly.
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={nameRef}
                          id="name"
                          label="Your Name"
                          variant="outlined"
                          error={err === 1}
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="John Doe"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={emailRef}
                          id="email"
                          label="Email Address"
                          variant="outlined"
                          error={err === 2}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="john@example.com"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={mobileRef}
                          id="mobile"
                          label="Mobile Number"
                          variant="outlined"
                          error={err === 3}
                          value={mob}
                          onChange={(e) => setMob(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="+91 98765 43210"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={subjectRef}
                          id="subject"
                          label="Enquiry For"
                          variant="outlined"
                          error={err === 4}
                          value={subj}
                          onChange={(e) => setSubj(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Web Development, ERP, etc."
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          ref={messageRef}
                          id="message"
                          label="Your Message"
                          variant="outlined"
                          error={err === 5}
                          value={msg}
                          multiline
                          rows={4}
                          onChange={(e) => setMsg(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Tell us about your project requirements..."
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Box style={{ textAlign: 'center', marginTop: 8 }}>
                          <Button
                            onClick={onSubmit}
                            disabled={disablebutton}
                            className={classes.submitButton}
                          >
                            <SendIcon style={{ marginRight: 8, fontSize: 20 }} />
                            {disablebutton ? "Sending..." : "Send Message"}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Fade>
              </Grid>

              {/* Contact Info */}
              <Grid item xs={12} md={5}>
                <Fade in={true} timeout={1200}>
                  <Box className={classes.contactCard}>
                    <Typography className={classes.contactTitle}>
                      Contact Information
                    </Typography>

                    <Box className={classes.contactItem}>
                      <PlaceIcon />
                      <Typography className={classes.contactText}>
                        201, Reliance Avans Bliss, Jayabheri Enclave,
                        Gachibowli, Hyderabad, Telangana 500032
                      </Typography>
                    </Box>

                    <Box className={classes.contactItem}>
                      <EmailIcon />
                      <Typography className={classes.contactText}>
                        contact@arawinz.com<br />
                        arawinzsoft@gmail.com
                      </Typography>
                    </Box>

                    <Box className={classes.socialContainer}>
                      <a
                        href="https://www.linkedin.com/company/arawinz-soft-solutions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                      >
                        <LinkedInIcon />
                      </a>
                      <a
                        href="https://www.youtube.com/@arawinzsoftsolutions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                      >
                        <YouTubeIcon />
                      </a>
                      <a
                        href="https://instagram.com/arawinzsoftsolutions/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                      >
                        <InstagramIcon />
                      </a>
                      <a
                        href="https://www.facebook.com/Arawinz-Soft-Solutions-100197325544506/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                      >
                        <FacebookIcon />
                      </a>
                    </Box>
                  </Box>
                </Fade>
              </Grid>
            </Grid>

            {/* Quote Section */}
            <Fade in={true} timeout={1400}>
              <Box className={classes.quoteSection}>
                <TypingQuote
                  text={`"At Arawinz, we prioritize understanding our clients' unique requirements and are dedicated to developing solutions that are not only scalable and secure but also innovative, user-friendly, and efficient. Our focus is on delivering top-quality, reliable, and adaptable products that meet the evolving demands of our clients."`}
                  className={classes.quoteText}
                />
                <Typography className={classes.quoteAuthor}>
                  — Arawinz Team
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>
      )}
      
    </div>
  );
};

